module.exports = {"title":"Voorstelling boek Het aards paradijs","date":"2013-04-01T00:00:00Z","layout":"post","attachment":"StudieAardsParadijs.pdf","linktext":"Lees kennismaking","body":"<p>Presentatie van het <strong>boek</strong> over <strong>het thema het aards paradijs</strong>, belicht vanuit het werk van <strong>Terrence Malick</strong> (<strong>The New World</strong> en <strong>The Tree of Life</strong>).</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./blog/2015-01-07-BoekAardsParadijs/index.md
// module id = 969
// module chunks = 0